export const TYPES = {
  GET_ALL_BRANCHS_SUCCESS: "branch/GET_ALL_BRANCHS_SUCCESS",
  GET_STAFF_BRANCHS_SUCCESS: "branch/GET_STAFF_BRANCHS_SUCCESS",
  GET_DETAIL_SUCCESS: "branch/GET_DETAIL_SUCCESS",
  GET_BRANCHS_OWNER_SUCCESS: "branch/GET_BRANCHS_OWNER_SUCCESS",
  GET_DETAIL_BRANCH_SUCCESS: "branch/GET_DETAIL_BRANCH_SUCCESS",
};
